<script lang="ts" setup>
    definePageMeta({
        middleware: 'auth',
    })
</script>

<template>
    <q-layout view="lhh LpR lff">
        <q-header elevated>
            <bz-main-toolbar />
        </q-header>
        <q-page-container>
            <slot />
        </q-page-container>
    </q-layout>
</template>

<style scoped></style>
